import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom"; //make sure to import all the components.
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
import translator from "../../../utils/translator";

export class Reports extends Component {
	static propTypes = {
		prop: PropTypes
	};

	render() {
		let main = (
			<>
				<div class="card user-profile-card">
					<div class="card-body">
						<div class="form-group">
							<h2 style={{ color: "#16448e" }}>{translator("Reports", "quote_reporting_header")}</h2>
						</div>
						<ul class="list-group">
							<Link style={{ textDecoration: "none" }} to={{ pathname: "/settings/reports/quote-reporting/Active-Quotes" }} exact><li class="list-group-item">{translator("Reports", "active_quotes")}</li></Link>
							<Link style={{ textDecoration: "none" }} to={{ pathname: "/settings/reports/quote-reporting/YTD-Quotes" }} exact><li class="list-group-item">{translator("Reports", "ytd_quotes")}</li></Link>
							<Link style={{ textDecoration: "none" }} to={{ pathname: "/settings/reports/quote-reporting/YTD-Archived-Quotes" }} exact><li class="list-group-item">{translator("Reports", "ytd_archived_quotes")}</li></Link>
							<Link style={{ textDecoration: "none" }} to={{ pathname: "/settings/reports/quote-reporting/Last-Year-Quotes" }} exact><li class="list-group-item">{translator("Reports", "last_year_quotes")}</li></Link>
						</ul>
					</div>
				</div>
				<div class="card user-profile-card">
					<div class="card-body">
						<div class="form-group">
							<h2 style={{ color: "#16448e" }}>{translator("Reports", "standard_reports_header")}</h2>
						</div>
						<ul class="list-group">
							<Link style={{ textDecoration: "none" }} to={{ pathname: "/settings/reports/standard-reports/Summary-by-Customer" }} exact><li class="list-group-item">{translator("Reports", "summary_by_customer")}</li></Link>
							<Link style={{ textDecoration: "none" }} to={{ pathname: "/settings/reports/standard-reports/Summary-by-Vendor" }} exact><li class="list-group-item">{translator("Reports", "summary_by_vendor")}</li></Link>
							<Link style={{ textDecoration: "none" }} to={{ pathname: "/settings/reports/standard-reports/Summary-by-Consultant" }} exact><li class="list-group-item">{translator("Reports", "summary_by_consultant")}</li></Link>
						</ul>
					</div>
				</div>
			</>
		);

		return (
			<SettingsWrapper header={translator("Reports", "page_header")} main={main} />
		);
	}
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Reports);
